<template>
    <div>
        <div id="div-modal-cxc" class="d-flex justify-content-center">
            <div id="div-cxc" class="w-100">
                <div class="card-body w-100">
                    <div class="row">
                        <!--Filtro-->
                        <div class="col-md-12 py-2 px-4">
                            <div class="row d-flex">
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mt-2">
                                    <div class="input-group">
                                        <span class="input-group-text ">Desde</span>
                                        <input type="date" aria-label="shift_date" class="form-control form-control-sm" id="init" v-model="filter.init" @change="mtdGetData"/>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mt-2">
                                    <div class="input-group">
                                        <span class="input-group-text ">Hasta</span>
                                        <input type="date" aria-label="shift_date" class="form-control form-control-sm" id="end" v-model="filter.end" @change="mtdGetData"/>
                                    </div>
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                                    <div class="input-group input-group">
                                        <span class="input-group-text text-white bg-main"
                                        ><i class="fas fa-search"></i
                                        ></span>
                                        <input
                                        @keyup="calculateData(7)"
                                        v-model="search"
                                        type="text"
                                        class="form-control form-control"
                                        placeholder="Buscar Paciente"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--Fin Filtro-->
                        <!-- paginado -->
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center mb-3 px-4">
                            <div v-if="cpData.length > 0" class="d-flex justify-content-end">
                                <nav aria-label="Page navigation example">
                                    <ul class="pagination mb-1">
                                        <li class="page-item">
                                            <a class="page-link page" href="javascript:void(0)" @click="backPage">Anterior</a>
                                        </li>
                                        <li v-if="limitedStepPagination[0] !== 1" class="page-item">
                                            <a :class="selectPage === 1 ? 'page-link active' : 'page-link'" href="javascript:void(0)" @click="selectedPage(1)">1</a>
                                        </li>
                                        <li v-if="limitedStepPagination[0] > 2" class="page-item disabled">
                                            <span class="page-link">...</span>
                                        </li>

                                        <li v-for="(item, index) in limitedStepPagination" :key="index" class="page-item">
                                            <a :class="selectPage === item ? 'page-link active' : 'page-link'" href="javascript:void(0)" @click="selectedPage(item)">{{ item }}
                                            </a>
                                        </li>
                                        <li v-if=" limitedStepPagination[limitedStepPagination.length - 1] <stepPagination.length - 1" class="page-item disabled">
                                            <span class="page-link">...</span>
                                        </li>
                                        <li v-if=" limitedStepPagination[limitedStepPagination.length - 1] !== stepPagination.length" class="page-item">
                                            <a :class="selectPage === limitedStepPagination.length + 2 ? 'page-link active':'page-link'" href="javascript:void(0)" @click="selectedPage(stepPagination.length)">{{ stepPagination.length }}
                                            </a>
                                        </li>
                                        <li class="page-item">
                                            <a class="page-link page" href="javascript:void(0)" @click="nextPage">Siguiente</a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        <div class="col-md-12" id="content-timelinetable">
                            <table id="tb-cxc" class="table table-bordered border-main">
                                <caption class="py-0 my-0"></caption>
                                <thead class="bg-main">
                                    <tr class=" table-th text-white text-center font-size">
                                        <th class="table-th-number">N°</th>
                                        <th>FECHA</th>
                                        <th>PACIENTE</th>
                                        <th>ACTO MED.</th>
                                        <th>HORA</th>
                                        <th>SERVICIO</th>
                                        <th>COMENTARIO</th>
                                        <th class="table-th-acciones">ACCIONES</th>
                                    </tr>
                                </thead>
                                <tbody class="border-main">
                                    <tr class="table-body text-center font-size" v-if="cpData.length === 0">
                                        <td colspan="8" class="text-center">No hay Registros</td>
                                    </tr>
                                    <tr class="table-body text-center font-size" v-for="(item, index) in cpData" :key="index">
                                        <td>{{index+1}}</td>
                                        <td>{{ item.date | formatDate}}</td>
                                        <td class="nowrap">
                                            <template v-if="item.patient">
                                                {{ item.patient.document }} - {{ item.patient.name}}
                                            </template>
                                            <template v-else>
                                                -
                                            </template>
                                        </td>
                                        <td class="nowrap">
                                            <template v-if="item.medicalact">
                                                {{ item.medicalact.id }} - {{ item.medicalact.date | formatDate }}
                                            </template>
                                            <template v-else>
                                                -
                                            </template>
                                        </td>
                                        <td class="nowrap">
                                            {{ item.start_time }} - {{ item.end_time  }}
                                        </td>
                                        <td class="">
                                            {{ item.services ? item.services.name : '-' }}
                                        </td>
                                        <td class="observation-column" style="font-size: 10px">{{ item.comment ? item.comment : '-' }}</td>
                                        <td>
                                            <div class="text-center d-flex justify-content-center">
                                                <button 
                                                    @click="mtdModalShow(item.id)" class="btn btn-primary btn-sm rounded-circle bootom">
                                                    <i class="fas fa-file"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <cModalReserMultimediaVue :id="modal.id" :payload="modal.payload" :title="modal.title"
        :boo_modal="modal.modal_form" @closeModal="closeModal" @registerFile="registerFile" @deleteFile="deleteFile" />
        <SweetAlert :swal="swal" ref="SweetAlert" />
    </div>
</template>

<script>
import { mapActions} from "vuex";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import cModalReserMultimediaVue from './Modals/cModalReserMultimedia.vue';
import moment from "moment";
export default {
    name:"lista-reservas",
    components:{
        SweetAlert,
        cModalReserMultimediaVue
    },
    data() {
        return {
            swal: null,
            search:"",
            dataShow: [],
            reservas: [],
            modal: {
                title: '',
                modal_form: false,
                id: null,
                payload: [],
            },
            filter: {
                init: null,
                end: null,
            },
            showTable: false,
            //Pag
            page: 0,
            selectPage: 1,
            stepPagination: [],
            totalPagesToShow: 4,
            action: "",
        };
    },
    created() {
        moment.locale("es");
        this.filter.end =
            moment().format("L").substr(6, 4) +
            "-" +
            moment().format("L").substr(3, 2) +
            "-" +
            moment().format("L").substr(0, 2);
        this.filter.init = this.filter.end;
        this.mtdGetData();
    },
    watch: {
        selectPage() {
            this.calculateData(7);
        },
    },
    computed: {
        classTh() {
            return 'align-middle border border-5 bg-main border-white';
        },
        
        cpData() {
            return this.dataShow;
        },

        limitedStepPagination() {
            const totalPages = this.stepPagination.length;
            const currentPage = this.selectPage;

            let startPage = 1;
            let endPage = totalPages;
            if (totalPages > this.totalPagesToShow) {
                const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

                if (currentPage > halfPagesToShow) {
                    startPage = currentPage - halfPagesToShow;
                    endPage = currentPage + halfPagesToShow - 1;

                    if (endPage > totalPages) {
                        endPage = totalPages;
                        startPage = totalPages - this.totalPagesToShow + 1;
                    }
                } else {
                    endPage = this.totalPagesToShow;
                }
            }

            return Array.from({
                    length: endPage - startPage + 1,
                },
                (_, i) => startPage + i
            );
        },
    },
    methods: {
        ...mapActions(["get", "post"]),

        mtdGetData() {
            this.post({
                url: this.$store.getters.get__url + "/Rehabilitation/list/mtdGetReserva",
                token: this.$store.getters.get__token,
                params: {
                    init: this.filter.init,
                    end: this.filter.end,
                },
            })
            .then((response) => {
                this.reservas = response.data;
                this.calculateData(7);
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        },

        calculateData(items) {
            if (!this.reservas || !this.reservas.length) {
                return (this.dataShow = []);
            }
            let filteredData = this.reservas;
            let indexInitial = this.selectPage;
            if (this.search.length >= 2 && this.search != "") {
                let query = this.search.toString().toUpperCase();
                filteredData = this.reservas.filter((element) => {
                    let name = element.patient.name.toString().toUpperCase();
                    let document = element.patient.document.toString().toUpperCase();
                    return name.includes(query) || document.includes(query);
                });
                indexInitial = 1;
            }
            let totalPages = Math.ceil(filteredData.length / items);
            this.stepPagination = Array.from({
                    length: totalPages,
                },
                (_, index) => index + 1
            );

            let startIndex = (indexInitial - 1) * items;
            let endIndex = startIndex + (items - 1);
            this.dataShow = filteredData.slice(startIndex, endIndex + 1);
            this.count = this.count + 1;
        },

        //Modals
        mtdModalShow: function (id) {
            this.get({
                url: this.$store.getters.get__url + "/Rehabilitation/list/mtdGetMultimedia/"+ id,
                token: this.$store.getters.get__token,
            })
            .then((response) => {
                if(response.statusCode == 200){
                    this.modal.title = 'Arc. Multimedia';
                    this.modal.id = id;
                    this.modal.payload = response.data;
                    this.modal.modal_form = true;
                }
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        },

        closeModal: function () {
            this.modal = {
                title: '',
                modal_form: false,
                id: null,
                payload: [],
            }
        },

        registerFile: function (payload_detail, id) {
          let formData = new FormData();
          formData.append("file", payload_detail.url);
          formData.append("id", id);
          this.post({
              url: this.$store.getters.get__url + "/Rehabilitation/list/registerMultimedia",
              token: this.$store.getters.get__token,
              params: formData,
          })
          .then(response => {
            if(response.data.state == 0){
                this.$refs.SweetAlert.showSuccess("Registro Exitoso");
                this.mtdModalShow(id);
            }else{
                this.$refs.SweetAlert.showError("Error");
            }
          })
          .catch(errors => {
            this.$refs.SweetAlert.showError(errors);
          })
        },

        deleteFile: function (idMul, id) {
          this.get({
              url: this.$store.getters.get__url + "/Rehabilitation/list/deleteMultimedia/" + idMul,
              token: this.$store.getters.get__token,
          })
          .then(response => {
            if(response.data.state == 0){
              this.$refs.SweetAlert.showSuccess("Eliminación Exitosa");
              this.mtdModalShow(id);
            }else{
                this.$refs.SweetAlert.showError("Error");
            }
          })
          .catch(errors => {
            this.$refs.SweetAlert.showError(errors);
          })
        },

        //Paginacion
        backPage() {
            this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
        },
        nextPage() {
            this.selectPage =
                this.selectPage < this.stepPagination.length ?
                this.selectPage + 1 :
                this.stepPagination.length;
        },
        selectedPage(page) {
            this.selectPage = page;
        },
        mtdNumber: function (index) {
            return index + 1 + (this.selectPage - 1) * 10;
        },
    },
    filters: {
        formatDate(date) {
        return date != null ? moment(date).format("DD/MM/YYYY") : "-";
        },
    },
};
</script>

<style lang="scss" scoped>
.font-size {
    font-size: 12.5px !important; 
}
.nowrap {
    white-space: nowrap;
}
.observation-column {
  max-width: 100px; 
  white-space: normal;
  word-wrap: break-word; 
}
.bootom {
  background-color: #2f395c !important; 
  border: 0.5px solid #2f395c !important;
}
</style>
    